export default function provisionalModuleDataBasedOnLanguage(language) {
  if (!language || language === "nb-NO" || language === "no-NO") {
    return {
      addedToCart: "har blitt lagt til i handlekurven din.",
      goToCart: "Gå til handlekurven",
      cartLink: "/handlekurv"
    }
  }

  if (language === "en-US") {
    return {
      addedToCart: "has been added to your cart.",
      goToCart: "Go to cart",
      cartLink: "/en-US/shopping-cart"
    }
  }

  if (language === "fr-FR") {
    return {
      addedToCart: "a été ajouté à votre panier.",  
      goToCart: "Aller au panier",
      cartLink: "/shopping-cart"
    }
  }

  return {
    addedToCart: "has been added to your cart.",
    goToCart: "Go to cart",
    cartLink: "/en-US/shopping-cart"
  }
}